import { Injectable } from '@angular/core';
import { ProfileApiService } from '@fantaz/shared/data-access/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, withLatestFrom } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ReferralsActions from './referrals.actions';
import { ReferralsState } from './referrals.reducer';
import { getReferralsPagination } from './referrals.selectors';

@Injectable()
export class ReferralsEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferralsActions.init),
      mergeMap((action) => {
        return this.profileApiService
          .fetchReferralInfo(action.options)
          .pipe(
            map((data) =>
              ReferralsActions.loadReferralsSuccess({ referrals: data }),
            ),
          );
      }),
      catchError((error) => {
        console.error('Error', error);
        return of(ReferralsActions.loadReferralsFailure({ error }));
      }),
    ),
  );

  refetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferralsActions.refetch),
      withLatestFrom(this.referralStore.select(getReferralsPagination)),
      mergeMap((action, pagination) => {
        return this.profileApiService
          .fetchReferralInfo({
            ...(pagination as any),
          })
          .pipe(
            map((data) =>
              ReferralsActions.loadReferralsSuccess({ referrals: data }),
            ),
          );
      }),
      catchError((error) => {
        console.error('Error', error);
        return of(ReferralsActions.loadReferralsFailure({ error }));
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly referralStore: Store<ReferralsState>,
    private readonly profileApiService: ProfileApiService,
  ) {}
}
